import { PURCHASER_API_BASE_URL, getHeaders } from "../Constants";
import type { AsyncRunEvent, AsyncRunStatus } from "../../util/useAsyncRun";

/**
 * Wire shape for an `async_run` row returned by the listing endpoint.
 * Mirrors `AsyncRunRow` in purchaser-api-work/services/async-run/types.ts,
 * with Date fields serialized as ISO strings the way every other API does.
 */
export type AsyncRunRow = {
    id: number;
    teamId: number;
    createdByUserId: number;
    type: "leveling_view";
    status: AsyncRunStatus;
    startedAt: string | null;
    completedAt: string | null;
    error: string | null;
    progress: { events: AsyncRunEvent[] };
    /** Leveling-view: `{ rfqId, levelingViewId?, title? }`. */
    entityRef: { rfqId?: number; levelingViewId?: string; title?: string };
    createdAt: string;
};

export type ListAsyncRunsResponse = { runs: AsyncRunRow[] };

export type ListAsyncRunsFilter = {
    rfqId?: number;
    type?: "leveling_view";
    statuses?: AsyncRunStatus[];
    limit?: number;
};

export default {
    listAsyncRuns: (filter: ListAsyncRunsFilter = {}): Promise<ListAsyncRunsResponse> => {
        const params = new URLSearchParams();
        if (filter.rfqId !== undefined) params.set("rfqId", String(filter.rfqId));
        if (filter.type) params.set("type", filter.type);
        if (filter.statuses && filter.statuses.length > 0) {
            params.set("status", filter.statuses.join(","));
        }
        if (filter.limit !== undefined) params.set("limit", String(filter.limit));
        const qs = params.toString();
        return fetch(
            `${PURCHASER_API_BASE_URL}/async-runs${qs ? `?${qs}` : ""}`,
            { headers: getHeaders() },
        ).then(res => res.json());
    },
};
